import { memo } from 'react';

/**
 * SVG cumulative-function overlay driven by timeline (tParamsCum).
 * Draws the curve traced out up to the current timeline position.
 * @param {{ axis, tParamsCum, paramX, paramY, color, dashArray, strokeWidth, showRegion }} props
 */
function IntFigCFunction({
  axis,
  tParamsCum,
  paramX, paramY,
  color = '#1f76D2',
  dashArray = '0 0',
  strokeWidth = 0.02,
  showRegion = false,
}) {
  if (!tParamsCum || !tParamsCum[paramY]) return null;

  const ys = tParamsCum[paramY].map(v => 1 - (v - axis.min_y) / (axis.max_y - axis.min_y));
  const xs = paramX === -1
    ? ys.map((_, i) => (i - axis.min_x) / (axis.max_x - axis.min_x))
    : tParamsCum[paramX].map(v => (v - axis.min_x) / (axis.max_x - axis.min_x));

  if (xs.length < 2) return null;

  return (
    <svg
      width="100%" height="100%"
      viewBox="0 0 1 1"
      preserveAspectRatio="none"
      style={{ position: 'absolute', inset: 0 }}
    >
      {xs.slice(0, -1).map((x, i) => (
        <line
          key={i}
          x1={xs[i]}   y1={ys[i]}
          x2={xs[i + 1]} y2={ys[i + 1]}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray={dashArray}
        />
      ))}
    </svg>
  );
}

export default memo(IntFigCFunction);
